var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.root }, [
    _vm.value
      ? _c("div", { class: _vm.$style.categoryDetails }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v(_vm._s(_vm.icon)),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.text || "___"))]),
        ])
      : _c("div", { class: _vm.$style.categoryDetails }, [
          _c(
            "i",
            { staticClass: "material-icons", class: _vm.$style.warning },
            [_vm._v("warning")]
          ),
          _c("span", [_vm._v(_vm._s(_vm.label))]),
        ]),
    _c(
      "div",
      { staticClass: "rbInputContainer", class: _vm.$style.categorySelect },
      [
        _c("i", { staticClass: "material-icons icon" }, [_vm._v("face")]),
        _c(
          "rb-select",
          {
            staticClass: "simple",
            attrs: { value: _vm.value },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
            },
          },
          [
            _c("rb-option", { attrs: { value: null } }, [
              _vm._v(" " + _vm._s(_vm.label) + " "),
            ]),
            _vm._l(_vm.options, function (option) {
              return _c(
                "rb-option",
                { key: option.id, attrs: { value: option.id } },
                [_vm._v(" " + _vm._s(option.name) + " ")]
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }